import GooglePicker from "react-google-picker";
import { IGDriveFile } from "intake_shared/src/types";
import { Button } from "../Button/Button";
import styles from "./GDriveSelect.module.scss";

const CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID;
const DEVELOPER_KEY = process.env.REACT_APP_FIREBASE_API_KEY;

export default function GDriveSelect({
    buttonLabel,
    onSelectFiles,
    mimeTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"],
}: {
    buttonLabel: string;
    onSelectFiles: (files: IGDriveFile[]) => void;
    mimeTypes?: string[];
}) {
    return (
        <GooglePicker
            clientId={CLIENT_ID}
            developerKey={DEVELOPER_KEY}
            scope={["https://www.googleapis.com/auth/drive.readonly"]}
            onChange={(data: any) =>
                data.action === "picked" && onSelectFiles(data.docs)
            }
            onAuthFailed={(data: any) => console.log("on auth failed:", data)}
            multiselect={true}
            navHidden={true}
            authImmediate={false}
            mimeTypes={mimeTypes}
            viewId={"DOCS"}
        >
            <div className={styles.gdriveSelect}>
                <Button>{buttonLabel}</Button>
            </div>
        </GooglePicker>
    );
}
